import React from "react";
import { Link } from "react-router-dom";

import { AuthCard } from "../../../common/u1/AuthCard";
import { AuthHeader } from "../../../common/u1/AuthHeader";
import { ArrowRight, MailIcon } from "../../../../assets/ui/icons";

/* Step 2 — "help is on the way". */
export const SentStep = ({ email }) => (
  <AuthCard>
    <div className="w-full text-center">
      <span
        aria-hidden="true"
        className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-[var(--field-inset)] border border-[var(--field-inset-border)] text-[var(--orange)]"
      >
        <MailIcon size={22} />
      </span>

      <AuthHeader
        title="Help is on the way"
        subtitle={
          <>
            We're searching our records for the TREVEX account linked to{" "}
            <b className="font-bold text-[var(--ink)]">{email}</b>.
          </>
        }
      />

      <p className="mx-auto mt-4 max-w-[380px] text-[12.5px] leading-[1.55] text-[var(--muted)] font-sans">
        If we find a match you'll get an email with instructions. Nothing after
        15 minutes? Check the address you entered, and your spam folder.
      </p>

      <div className="mt-6">
        <Link
          to="/login"
          className="inline-flex items-center gap-1.5 text-[12.5px] font-semibold text-[var(--ink-2)] hover:text-[var(--ink)] font-sans"
        >
          <ArrowRight size={14} className="rotate-180" /> Back to log in
        </Link>
      </div>
    </div>
  </AuthCard>
);

export default SentStep;
